var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cf4ea79757d122be988a1f2c1839c70faf6ac7f9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gcb-shop@apptiva-ag"]={id:"cf4ea79757d122be988a1f2c1839c70faf6ac7f9"};
      